export const GRANTS = Object.freeze({
  FULL: "full",
  OWNERSHIP: "ownership",
  PROJECT_SCOPED: "project-scoped",
});

export const HTTP_METHODS = Object.freeze({
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  PATCH: "PATCH",
  DELETE: "DELETE",
});
